import React from "react";

const ResponsiblePlay = () => {
  return (
    <div className="Associate__container">
      <div className="box">
        <h1>CoinStorey Responsible Play</h1>
        <h2>Our Mission Statement</h2>
        <p>
          Hansis IT Supervision Private Limited encourages all its players to
          play responsibly. We are committed to helping players who wish to stop
          playing or who wish to limit the amount that they play.
        </p>
        <h2> Ensure Responsible Play</h2>
        <ul></ul>
        <li>
          Players must be 18 years of age to play skill games for real money.{" "}
        </li>
        <li>
          There is an option for players to set the daily and monthly playing
          limit, by sending us a request from their registered email address.
          Once set, these limits can be changed again only after 72 hours from
          the previous change.
        </li>
        <li>
          {" "}
          Players can request for their accounts to be temporarily blocked, if
          they want to self-exclude themselves for some time.
        </li>
        <li>
          Players can follow our ‘Guide to Responsible Play’ in order to keep a
          check on their play behaviour.
        </li>

        <h1> Guide to Responsible Play</h1>
        <p>
          Sometimes, players may find it hard to recognize that their online
          play is getting out of control. A common reaction is to minimize, hide
          or deny such problems and the harm it could be causing. Some people
          will lie to themselves about how much money or time is being spent on
          online playing.
        </p>
        <b>
          Following are some of the best practices to help you play responsibly:
        </b>
        <ul>
          <li>Play in moderation and only for entertainment.</li>
          <li>Do not play to make money or escape problems.</li>
          <li>Never chase your losses while playing.</li>
          <li>Set aside an entertainment budget.</li>
          <li>
            Keep track of the time and monitor the amount of money you spend.{" "}
          </li>
          <li>
            Use the Add Cash limit option to help control the amount you spend.
          </li>
          <li>
            {" "}
            Balance the time you spend on playing online games with other
            leisure activities.
          </li>
        </ul>
        <h1> Recognize whether you are not playing responsibly </h1>
        <b>Do you do any of the following:</b>
        <ul>
          <li>
            {" "}
            Do you spend more money and time than you intend on playing games?
          </li>
          <li>Do you feel guilty or ashamed while playing habits?</li>
          <li>Do you try to win back your losses? </li>
          <li>
            {" "}
            Do you miss important things in life such as family time, work,
            leisure activities, appointments to play games?{" "}
          </li>
          <li>Do you think about your gameplay all day long? </li>
          <li>
            Do you have arguments with friends or family about your playing
            habits?{" "}
          </li>
          <li>Do you lie or steal to get money to play games?</li>
          <li>Do you have debts or struggled financially to play games? </li>
          <li>Has playing games negatively impacted your professional life?</li>
          <li>
            {" "}
            Do you have relationship problems like arguments, disagreements or
            loss of Connection with friends and family?
          </li>
          <li>
            Have you experienced an increase in stress, depression or panic
            attacks due to playing games?
          </li>
        </ul>

        <h1>Game Prudence</h1>
        <p>
          Game Prudence is an independent body that aims to help players,
          playing on skill-gaming websites, in incorporating responsible gaming
          habits into their lifestyles. Game Prudence is a non-judgemental
          platform providing you with private, confidential and free of cost
          psychological counselling, wherein you can identify how healthy your
          gaming habits are as well as receive professional guidance from
          experts. All Game Prudence experts are certified by iGaming Academy.
          To Learn More..
        </p>
        <h1>Get Help from Game Prudence </h1>
        <p>
          If you suspect that you are facing any of the issues mentioned above
          and as a result have not been playing responsibly, or if you know
          someone who is facing similar issues, kindly seek help immediately.
          You can get help by registering your request at Game Prudence.{" "}
        </p>
        <h2>Hacking awareness</h2>
        <h3>What to Do Before You’re Hacked</h3>
        <ul>
          <li>
            Use unique passwords for important sites, like your bank and email
            That way, someone who knows one of your passwords won’t suddenly
            have access to all your important accounts.
          </li>
          <li>
            Choose strong passwords that are harder to crack. Some people find
            password managers — software that stores and remembers your
            passwords for you — a helpful way to keep things straight. If you
            use a password manager, make sure to select a unique, strong
            password for it, too. Many password managers will let you know
            whether the master password you’ve created is strong enough.
          </li>
          <li>
            Safeguard your usernames and secret passwords Think twice when
            you’re asked to enter credentials like usernames and secret
            passwords. Never provide them in response to an email. If the email
            or text seems to be from your bank, for example, visit the bank
            website directly rather than clicking on any links or calling any
            numbers in the message. Scammers impersonate well-known businesses
            to trick people into giving out personal information. ECSU will
            never, never ask for your secret password.
          </li>
          <li>
            Turn on two-factor authentication if your service provider offers it
            A number of online services offer “two-factor authentication,” where
            getting into your account requires a password plus something else —
            say, a code sent to your smartphone — to prove it’s really you.
          </li>
          <li>
            Don’t click on links or open attachments in emails unless you know
            who sent them and what they are That link or attachment could
            install malware on your computer. Also do your part: don’t forward
            random links.
          </li>
          <li>
            Download free software only from sites you know and trust If you’re
            not sure who to trust, do some research before you download any
            software. Free games, file-sharing programs, and customized toolbars
            also could contain malware.
          </li>
          <li>
            Don’t treat public computers like your personal computer If it’s not
            your computer, don’t let a web browser remember your passwords, and
            make sure to log out of any accounts when you’re done. In fact, if
            you can help it, don’t access personal accounts — like email, or
            especially bank accounts — on public computers at all. (Also be
            careful any time you use public Wi-Fi.)
          </li>
          <li>
            Learn more at the Federal Trade Commission website
            https://www.consumer.ftc.gov/topics/privacy-identity-online-security
          </li>
        </ul>
        <p>
          <b> Disclaimer</b>: For any promotion or account related queries, you
          can reach out to us on{" "}
          <a href="mailto:team@coinstorey.com">team@coinstorey.com</a>
        </p>
      </div>
    </div>
  );
};

export default ResponsiblePlay;
